import axios from 'axios';
import {
  LOGIN_BY_SSO_URI,
  LOGIN_URI,
  REFRESH_SSO_TOKEN_URI,
  REFRESH_TOKEN_URI,
  SHARED_LOGIN_URI,
  decode,
  getAccessToken,
  refreshAccessToken,
} from '../services/auth';
import { errorInterceptor } from './interceptors';

const TIMEOUT = 15000;
const EXCLUDED_URI_FOR_AUTH_HEADER = [REFRESH_TOKEN_URI, LOGIN_URI];
const EXCLUDED_URI_FOR_REFRESH_TOKEN = [
  LOGIN_URI,
  SHARED_LOGIN_URI,
  REFRESH_TOKEN_URI,
  LOGIN_BY_SSO_URI,
  REFRESH_SSO_TOKEN_URI,
];

const parseUrl = () => {
  const l = window.location;
  return `${l.protocol}//${l.host}`;
};

const api = axios.create({
  baseURL: `${parseUrl()}/api`,
  timeout: TIMEOUT,
});

let refreshTokenPromise: Promise<any> | undefined;

api.interceptors.request.use(async (req) => {
  const accessToken = getAccessToken();
  const { exp } = accessToken ? decode(accessToken) : { exp: undefined };

  if (!accessToken || EXCLUDED_URI_FOR_AUTH_HEADER.some((uri) => req.url?.endsWith(uri))) {
    return req;
  }

  if (
    !EXCLUDED_URI_FOR_REFRESH_TOKEN.some((uri) => req.url?.endsWith(uri)) &&
    exp &&
    new Date(exp * 1000) < new Date()
  ) {
    if (!refreshTokenPromise) {
      refreshTokenPromise = refreshAccessToken();
    }

    await refreshTokenPromise;
    refreshTokenPromise = undefined;
  }

  req.headers = {
    ...req.headers,
    authorization: `Bearer ${getAccessToken()}`,
  };

  return req;
});

api.interceptors.response.use((res) => res, errorInterceptor);

export default api;
